"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyOptionToJSON = exports.SurveyOptionFromJSONTyped = exports.SurveyOptionFromJSON = exports.instanceOfSurveyOption = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SurveyOption interface.
 */
function instanceOfSurveyOption(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyOption = instanceOfSurveyOption;
function SurveyOptionFromJSON(json) {
    return SurveyOptionFromJSONTyped(json, false);
}
exports.SurveyOptionFromJSON = SurveyOptionFromJSON;
function SurveyOptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'primaryText': !(0, runtime_1.exists)(json, 'primary_text') ? undefined : json['primary_text'],
        'isExclusive': !(0, runtime_1.exists)(json, 'is_exclusive') ? undefined : json['is_exclusive'],
    };
}
exports.SurveyOptionFromJSONTyped = SurveyOptionFromJSONTyped;
function SurveyOptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'primary_text': value.primaryText,
        'is_exclusive': value.isExclusive,
    };
}
exports.SurveyOptionToJSON = SurveyOptionToJSON;
